import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { Auth } from './auth';
import { BeneficiarySearch } from './beneficiarySearch';
import { PartnerExport } from './exportPartner';

const reducersToCombine = { Auth, BeneficiarySearch, PartnerExport };

export const persistConfig = { blacklist: ['_persist', 'persist'], key: 'EON', storage };

export const reducers = combineReducers(reducersToCombine);

export default persistReducer(persistConfig, reducers);
